import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { GavelOutlined } from '@mui/icons-material'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
import { useIntl } from 'react-intl'

interface MenuModerationProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuModeration = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuModerationProps) => {
  const { formatMessage } = useIntl()
  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/live-chat/moderation?page=1&page_size=10"
        selected={pathname.startsWith('/live-chat/moderation')}
      >
        <ListItemIcon>
          <GavelOutlined />
        </ListItemIcon>
        <ListItemText
          primary={formatMessage({
            id: 'liveChat.sidebar.moderation',
          })}
        />
      </MenuItem>
    </div>
  )
}
